<template>
  <div id="app">
    <div id="page_scroll_container">
      <div id="page_rotate_container">
        <div :class="pageLocation === 'home' ? 'page_visible' : 'page_invisible'">
          <div class="inhoud">
            <home />
          </div>
        </div>
        <div :class="pageLocation === 'info' ? 'page_visible' : 'page_invisible'">
          <div class="inhoud">
            <info />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import home from '@/views/Home.vue';
import info from '@/views/Info.vue';

import { mapGetters } from 'vuex';

export default {
  name: 'app',
  components: { home, info },
  data() {
    return {
      visibility: {
        home: true,
        info: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      pageLocation: 'pageLocation/location',
    }),
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/style.scss';
</style>
